import { setCommentDeleteRow as setCommentDeleteRowDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';


export type SetCommentDeleteRowProps = ApiMethodBase & {
    row: number;
};

export const setCommentDeleteRow = ({
    row,
}: SetCommentDeleteRowProps) => {
    setCommentDeleteRowDiagram(row);
};
